class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.js-accordion-btn');
    this.content = this.querySelector('.js-accordion-content');
    this.chevron = this.querySelector('.js-accordion-chevron');
  }

  connectedCallback() {
    if (!this.button || !this.content) return;
    this.button.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', !isOpen);

    if (!isOpen) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.content.style.maxHeight = this.content.scrollHeight + "px";
    this.content.style.opacity = "1";
    if (this.chevron) this.chevron.classList.add('rotate-180');
  }

  close() {
    this.content.style.maxHeight = "0";
    this.content.style.opacity = "0";
    if (this.chevron) this.chevron.classList.remove('rotate-180');
  }
}

// Définition du tag personnalisé <accordion-component>
if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', AccordionComponent);
}